import { useState, useCallback, useEffect } from 'react';
import { useAuth } from '@/core/auth/AuthContext';
import { useToast } from '@/components/ui';

// Mocking the API since the projects table schema isn't fully defined for N:N team relationships
const MOCK_AVAILABLE_PROJECTS = [
  { id: '101', name: 'Dự án Vinhome Grand Park', code: 'VGP-2024', status_code: 'active' },
  { id: '102', name: 'Công viên phần mềm Quang Trung', code: 'QTSC-01', status_code: 'planning' },
  { id: '103', name: 'Khu dân cư Ecopark', code: 'ECO-23', status_code: 'active' },
  { id: '104', name: 'Bảo dưỡng cảnh quan nhà máy Samsung', code: 'SS-MT', status_code: 'maintenance' },
];

export function useTeamProjects(teamId: string) {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  const { toast } = useToast();
  
  const [availableProjects, setAvailableProjects] = useState<any[]>([]);
  const [isLoadingProjects, setIsLoadingProjects] = useState(false);
  const [isMutating, setIsMutating] = useState(false);

  const fetchAvailableProjects = useCallback(async () => {
    if (!companyId || !teamId) return;
    setIsLoadingProjects(true);
    try {
      // MOCK: Replace with real Supabase query when schema is ready
      await new Promise(resolve => setTimeout(resolve, 500));
      setAvailableProjects(MOCK_AVAILABLE_PROJECTS);
    } catch (error) {
      console.error('Lỗi tải danh sách dự án:', error);
    } finally {
      setIsLoadingProjects(false);
    }
  }, [companyId, teamId]);

  useEffect(() => {
    fetchAvailableProjects();
  }, [fetchAvailableProjects]);

  const assignProjects = async (projectIds: string[], onSuccess?: () => void) => {
    if (!projectIds || projectIds.length === 0) return;
    setIsMutating(true);
    try {
      // MOCK: Replace with real Supabase insert/update
      await new Promise(resolve => setTimeout(resolve, 800));
      toast.success(`Đã giao thành công ${projectIds.length} dự án cho tổ đội`);
      onSuccess?.();
    } catch (error: any) {
      toast.error(error.message || 'Không thể giao dự án');
    } finally {
      setIsMutating(false);
    }
  };

  return {
    availableProjects,
    isLoadingProjects,
    isMutating,
    fetchAvailableProjects,
    assignProjects
  };
}
